import { QualifyingLifeEventType } from '@zorro/clients';
import { getToday, parseDate } from '@zorro/shared/formatters';
import { Text } from '@zorro/web/design-system';
import { $enum } from 'ts-enum-util';

export enum CoverageBannerVariant {
  BIRTH = 'BIRTH',
  FUTURE = 'FUTURE',
  PAST = 'PAST',
}

export function getCoverageBannerVariant(
  type: QualifyingLifeEventType | undefined,
  eventDate: Date | undefined
): CoverageBannerVariant | undefined {
  if (!type || !eventDate) return undefined;

  if (type === QualifyingLifeEventType.NEW_DEPENDENT)
    return CoverageBannerVariant.BIRTH;

  return parseDate(eventDate).isAfter(getToday())
    ? CoverageBannerVariant.FUTURE
    : CoverageBannerVariant.PAST;
}

export const getCoverageBannerText = (
  variant: CoverageBannerVariant,
  isOps: boolean
) =>
  $enum.mapValue(variant).with({
    [CoverageBannerVariant.BIRTH]: isOps ? (
      <>
        If the employee keeps their current plan, coverage is retroactive to the
        event date. If they switch plans, coverage starts the 1st of the month
        after they submit their election — and any change submitted{' '}
        <Text span fw={600} size="sm">
          within the last 3 business days of the month
        </Text>{' '}
        will be pushed to the 1st of the following month.
      </>
    ) : (
      <>
        Coverage is retroactive to the birth date if you keep your plan. If
        changing plans, coverage starts the 1st of the month after you submit
        your election, provided you submit it{' '}
        <Text span fw={600} size="sm">
          at least 3 business days before the end of the month
        </Text>
        . If you don&apos;t, coverage will begin the 1st of the following month.
      </>
    ),
    [CoverageBannerVariant.FUTURE]: isOps ? (
      <>
        Coverage will start on the 1st of the month following the event date, as
        long as the employee submits their election{' '}
        <Text span fw={600} size="sm">
          at least 3 business days before the end of the event month
        </Text>
        . If they submit later, coverage will begin the 1st of the following
        month.
      </>
    ) : (
      <>
        Coverage will start on the 1st of the month after your life event
        occurs, provided you submit your plan election{' '}
        <Text span fw={600} size="sm">
          at least 3 business days before the end of the month
        </Text>{' '}
        of your life event. If you don&apos;t, coverage will begin the 1st of
        the following month.
      </>
    ),
    [CoverageBannerVariant.PAST]: isOps ? (
      <>
        Coverage will start on the 1st of the month after the employee submits
        their election, as long as they submit it{' '}
        <Text span fw={600} size="sm">
          at least 3 business days before the end of the month
        </Text>
        . If they don&apos;t, coverage will begin the 1st of the following
        month.
      </>
    ) : (
      <>
        Coverage will start on the 1st of the month after you submit your
        election, provided you submit it{' '}
        <Text span fw={600} size="sm">
          at least 3 business days before the end of the month
        </Text>
        . If you don&apos;t, coverage will begin the 1st of the following month.
      </>
    ),
  });
